const HOME_URL = '/百度富文本编辑器ueditor/ueditor-master/'
const TOOLBAR = [
    [
        'bold', 'italic', 'underline', '|',
        'forecolor', 'backcolor', '|',
        'fontfamily', 'fontsize', '|',
        'justifyleft', 'justifycenter', 'justifyright', '|',
        'insertorderedlist', 'insertunorderedlist', '|',
        'undo', 'redo', '|',
        'inserttable', '|',
        'source', 'fullscreen'
    ]
]
export function createUEConfig(opts = {}) {
    const {
        height = 400,
        placeholder = '请输入内容...',
        readonly = false,
        serverUrl = '',
    } = opts

    return {
        UEDITOR_HOME_URL: HOME_URL,
        serverUrl,

        initialFrameHeight: height,
        initialFrameWidth: '100%',
        zIndex: 900,

        toolbars: TOOLBAR,
        readonly,
        placeholder,

        autoClearinitialContent: false,
        enableAutoSave: false,
        saveInterval: 500,

        wordCount: false,
        elementPathEnabled: false,
        enableContextMenu: true,
        autoSyncData: false,
        pasteplain: false,

        allowDivTransToP: false,
        disabledTableInTable: false,
    }
}